module.exports = __webpack_public_path__ + "img/couples-071.8a57bc23.jpg";